// eslint-disable-next-line import/no-named-default,import/no-unresolved
import { default as uiElements } from './UiElements'
// eslint-disable-next-line import/no-unresolved,import/no-named-default
import { default as formElements } from './Forms'
// import HeaderMenuCommon from './UiElements/HeaderMenuCommon'
// eslint-disable-next-line import/no-named-default
import { default as UiTabs } from './UiTabs'
// import UiModal from './UiElements/UiModal.vue'

export default function Components(Vue) {
  Vue.use(formElements)
  Vue.use(uiElements)
  Vue.use(UiTabs)
  // Vue.component(HeaderMenuCommon.name, HeaderMenuCommon)
  // Vue.component(UiModal.name, UiModal)
}



// WEBPACK FOOTER //
// ./src/js/components/app/index.js